import { Alert, Card, List } from 'antd';
import { useTranslation } from 'react-i18next';

export type PortalAnnouncements = {
  read_only?: true;
  advisory?: string;
  limit?: number;
  items: Array<{
    id: string;
    title: string;
    body_text?: string | null;
    section_name?: string;
    published_at?: string | null;
  }>;
};

/** Read-only class announcements soft-read for student / parent portals. Published items only. */
export default function PortalAnnouncementsCard({
  announcements,
  loading,
}: {
  announcements?: PortalAnnouncements;
  loading?: boolean;
}) {
  const { t } = useTranslation('education');
  if (!announcements) return null;
  return (
    <Card size="small" title={t('lmsPortalAnnouncements', { defaultValue: 'Class announcements' })} loading={loading}>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
        message={t('lmsPortalAnnouncementsHint', { defaultValue: 'Latest published announcements for the section.' })}
      />
      <List
        size="small"
        locale={{ emptyText: t('lmsNoRows', { defaultValue: 'Nothing here yet' }) }}
        dataSource={announcements.items}
        renderItem={(item) => (
          <List.Item key={item.id}>
            <List.Item.Meta
              title={item.title}
              description={
                <>
                  {item.body_text ? <div style={{ whiteSpace: 'pre-wrap' }}>{item.body_text}</div> : null}
                  <div>{item.published_at ? item.published_at.slice(0, 10) : '—'}</div>
                </>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
}
